import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { DispatchDashboardTab } from 'server/enums/DispatchDashboardTab';

import { PilotsNavbar } from 'data/models/PilotsNavbar';

export const enum PilotsHeaderTab {
    New,
    Movements,
    Search,
    Rotation
}

interface PilotsHeaderProps {
    selectedTab : PilotsHeaderTab;
    title : string;
    model : PilotsNavbar;
}

export const PilotsHeaderView = SuperCritical(({
    selectedTab,
    title,
    model: m
} : PilotsHeaderProps) =>
    <div className="pilots-header-shell"> 
        <div className="pilots-header">
            <ul className="pilots-nav-tabs">
                <NavItemLink tab={PilotsHeaderTab.New}
                    selectedTab={selectedTab}
                    href={`#!dispatchdashboard?id=${m.Id()}&tab=${DispatchDashboardTab.New}`}
                    // TH 10/20/2017 -- DC originally had this note in dispatchdashboard/model.ts:
                    // DC 08/16/2017 -- Minor Note: the Count takes in Unlisted Movements
                    // Users that view DDash can see the count and could appear "wrong" to them
                    text={(m.AcknowledgeCount() > 0) ? `New (${m.AcknowledgeCount()})` : `New`}
                    styles={(m.AcknowledgeCount() > 0) ? "pending" : ""} />
                <NavItemLink tab={PilotsHeaderTab.Movements}
                    selectedTab={selectedTab}
                    href={'#!dispatchdashboard?id=' + m.Id()}
                    text="Movements"
                    styles="" />
                <NavItemLink tab={PilotsHeaderTab.Search}
                    selectedTab={selectedTab}
                    href={`#!dispatchdashboard?id=${m.Id()}&tab=${DispatchDashboardTab.Search}`}
                    text="Search"
                    styles="" />
                {/* TH 10/19/2017 -- If they're already on rotation, assume they can view rotation. :) */}
                {(m.CanViewRotation() || selectedTab === PilotsHeaderTab.Rotation) &&
                    <NavItemLink tab={PilotsHeaderTab.Rotation}
                        selectedTab={selectedTab}
                        href={'#!rotationdashboard?id=' + m.Id()}
                        text="Rotation"
                        styles="" />
                }
            </ul>
            <h1 className="pilots-page-title">{title}</h1>
        </div>
    </div>
);

let NavItemLink = SuperCritical(({ tab, selectedTab, href, text, styles } : {
    tab : PilotsHeaderTab,
    selectedTab : PilotsHeaderTab,
    href : string,
    text : string,
    styles : string
}) =>
    <li className={cx('pilots-nav-item', {
            'pilots-nav-item-selected': selectedTab === tab,
            'pending-orders': styles === 'pending'
        })}>
        {/* TH 01/18/2017 -- Prevent default click action if this is already the selected tab.
            That way we don't alter the current query string if the user hits the selected tab button */}
        <a href={href} onClick={selectedTab === tab ? noDefault(() => {}) : undefined}>{text}</a>
    </li>
);



// WEBPACK FOOTER //
// ./apps/pilots/pilotsheader/view.tsx